<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 基础表格
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-button
            type="success"
            icon="el-icon-plus"
            class="handle-del mr10"
            @click="insertVisible = true"
            style="margin-right: 50px"
        >添 加
        </el-button>
      </div>
      <el-table
          :data="tableData"
          border
          class="table"
          ref="multipleTable"
          header-cell-class-name="table-header"
          @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column
            type="index"
            width="50"
            label="ID"
            align="center">
        </el-table-column>
        <el-table-column prop="bannerPic" label="轮播图">
          <template v-slot="scope">
            <img :src="scope.row.bannerPic" :preview-src-list="[scope.row.thumb]" min-width="70" height="70"/>
          </template>
        </el-table-column>
        <el-table-column prop="bannerType" label="轮播图类型"></el-table-column>
        <el-table-column prop="newsId" label="跳转的资讯ID或者活动ID"></el-table-column>
        <el-table-column prop="bannerStatus" label="状态">
          <template v-slot="scope">
            <el-switch
                active-text="上线"
                inactive-text="下线"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
                v-model="scope.row.bannerStatus"
                @click=change(scope.$index,scope.row)
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="bannerOrder" label="轮播图顺序"></el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template #default="scope">
            <el-button
                type="text"
                icon="el-icon-edit"
                @click="handleEdit(scope.$index, scope.row)"
            >编辑
            </el-button>
            <el-button
                type="text"
                icon="el-icon-delete"
                class="red"
                @click="handleDelete(scope.$index, scope.row)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination background
                     @current-change="handleCurrentChange"
                     :current-page="pageNum"
                     :page-size="pageSize" layout="total, prev, pager, next, jumper"
                     :total="totalCount">
      </el-pagination>
    </div>

    <!-- 添加弹出框 -->
    <el-dialog title="添加" v-model="insertVisible" width="50%" :before-close="close">
      <el-form ref="insertVisible" :model="banner" label-width="170px">
        <!--      action修改成oss上传图片的路径        -->
        <el-form-item label="活动图片">
          <el-upload
              action="https://yisheng.host/api/banner/upload"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :on-progress="uploadVideoProcess"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else-if="imageFlag == false" class="el-icon-plus avatar-uploader-icon"></i>
            <el-progress v-if="imageFlag == true" type="circle" :percentage="imageUploadPercent"
                         style="margin-top:30px;"></el-progress>
          </el-upload>
          <p style="color: #DD4A68;margin-left: 10px">建议图片尺寸：355 x 150</p>
        </el-form-item>
        <el-form-item label="轮播图类型">
          <el-select v-model="banner.bannerType" placeholder="请选择轮播图类型">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转的资讯ID或者活动ID">
          <el-input v-model="banner.newsId"></el-input>
        </el-form-item>
        <el-form-item label="轮播图顺序">
          <el-input v-model="banner.bannerOrder"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
                <span class="dialog-footer">
                    <el-button @click="closeInsert">取 消</el-button>
                    <el-button type="primary" @click="saveInsert">确 定</el-button>
                </span>
      </template>
    </el-dialog>

    <!-- 编辑弹出框 -->
    <el-dialog title="编辑" v-model="editVisible" width="50%" :before-close="close">
      <el-form ref="editForm" :model="banner" label-width="170px">
        <!--      action修改成oss上传图片的路径        -->
        <!--      action修改成oss上传图片的路径        -->
        <el-form-item label="活动图片">
          <el-upload
              action="https://yisheng.host/api/banner/upload"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :on-progress="uploadVideoProcess"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else-if="imageFlag == false" class="el-icon-plus avatar-uploader-icon"></i>
            <el-progress v-if="imageFlag == true" type="circle" :percentage="imageUploadPercent"
                         style="margin-top:30px;"></el-progress>
          </el-upload>
          <p style="color: #DD4A68;margin-left: 10px">建议图片尺寸：355 x 150</p>
        </el-form-item>
        <el-form-item label="轮播图类型">
          <el-select v-model="banner.bannerType" placeholder="请选择轮播图类型">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转的资讯ID或者活动ID">
          <el-input v-model="banner.newsId"></el-input>
        </el-form-item>
        <el-form-item label="轮播图顺序">
          <el-input v-model="banner.bannerOrder"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
                <span class="dialog-footer">
                    <el-button @click="closeEdit">取 消</el-button>
                    <el-button type="primary" @click="saveEdit">确 定</el-button>
                </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Banner",
  inject: ['reload'],
  data() {
    return {

      tableData: [],

      banner: {
        bannerId: '',
        bannerPic: '',
        bannerStatus: '',
        bannerOrder: '',
        bannerType: '',
        newsId: ''
      },

      options: [{
        value: '活动',
        label: '活动'
      }, {
        value: '首页',
        label: '首页'
      }],

      insertVisible: false,
      editVisible: false,

      imageUrl: '',

      // 默认显示第几页
      pageNum: 1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 1,
      // 默认每页显示的条数（可修改）
      pageSize: 10,

      idx: -1,
      id: -1,

      imageFlag: false,
      imageUploadPercent: ''
    }
  },
  created() {
    this.getData(this.pageSize, this.pageNum)
  },
  methods: {

    // 多选操作
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 获取数据
    getData(pageSize, pageNum) {
      this.$axios({
        method: "get",
        url: "/banner/getList",
        params: {"pageSize": pageSize, "pageNum": pageNum}
      }).then(response => {
        console.log(response)
        this.tableData = response.data.datas.bannerPageInfo.list
        this.totalCount = response.data.datas.bannerPageInfo.total
      })
    },

    close(done) {
      this.banner = {
        bannerId: '',
        bannerPic: '',
        bannerStatus: '',
        bannerOrder: '',
        bannerType: '',
        newsId: ''
      },
          this.imageUrl = '',
      done();
    },

    closeInsert() {
      this.banner = {
        bannerId: '',
        bannerPic: '',
        bannerStatus: '',
        bannerOrder: '',
        bannerType: '',
        newsId: ''
      },
      this.insertVisible = false;
      this.imageUrl = '';
    },

    closeEdit() {
      this.banner = {
        bannerId: '',
        bannerPic: '',
        bannerStatus: '',
        bannerOrder: '',
        bannerType: '',
        newsId: ''
      },
      this.editVisible = false;
      this.imageUrl = '';
    },

    // 添加
    saveInsert() {
      this.banner.bannerPic = this.imageUrl
      this.$axios({
        method: "post",
        url: "/banner/save",
        data: this.banner
      }).then(response => {
        console.log(response)
        if (response.data.code == 200) {
          this.$message.success(response.data.msg);
          this.reload();
        } else {
          this.$message.error(response.data.msg);
        }
      })
    },

    // 编辑操作
    handleEdit(index, row) {
      this.idx = index;
      this.banner = row;
      this.editVisible = true;
      this.imageUrl = row.bannerPic;
    },
    // 保存修改
    saveEdit() {
      this.banner.bannerPic = this.imageUrl
      this.$axios({
        method: "put",
        url: "/banner/edit",
        data: this.banner
      }).then(response => {
        console.log(response)
        if (response.data.code == 200) {
          this.$message.success(`修改第 ${this.idx + 1} 行成功`);
          this.reload();
        } else {
          this.$message.error("修改失败");
        }
      })
    },

    // 删除操作
    handleDelete(index, row) {
      console.log(row)
      if (row.roleId === "超级管理员") {
        this.$message.error("超级管理员无法删除");
        return;
      }
      // 二次确认删除
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      }).then(res => {
        if (res == "confirm") {
          this.$axios({
            method: "delete",
            url: "/banner/del",
            params: {"bannerId": row.bannerId}
          }).then(response => {
            if (response.data.code == 200) {
              this.$message.success("删除成功");
              this.reload()
              //this.tableData.splice(department, 1);
            } else {
              this.$message.error("删除失败");
            }
          })
        }
      })
    },

    change(index, row) {
      this.$axios({
        url: "/banner/edit",
        method: "put",
        data: row
      }).then(response => {
            console.log(response)
          }
      )
    },

    // 分页
    // 显示第几页
    handleCurrentChange(val) {
      // 切换页码时，要获取每页显示的条数
      this.getData(this.pageSize, val)

    },


    uploadVideoProcess(event, file) {
      this.imageFlag = true;
      this.imageUploadPercent = file.percentage.toFixed(0);
    },
    // 上传图片
    handleAvatarSuccess(res) {
      this.imageFlag = false;
      this.imageUploadPercent = 0;
      this.imageUrl = res.datas.map.url
    }

  }
}
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  display: block;
}
</style>
